import React, { useContext, useEffect, useState } from 'react'
import AccountInformationCard from '../../../utility/accountInformationCard';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import IconsColor from '../../../utility/iconsColor';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { useSearchParams } from 'react-router-dom';
import agent from '../../../../services/api';
import { MetaContext, MetaContextPayload } from '../../../../context/metaContext';
import { chatbotIntegrationAssignmentDataNew, createMetaIntegrationPayloadNew, globalIntegration, metaIntegrationFaceBookDataNew, metaIntegrationPhoneNumberData, metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import { isAgentOrAdmin, isOrganizationRoleAgent } from '../../../../utils/constants';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import GlobalPopUp from '../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import whatsAppIcon from "../../../../assets/images/chatbot/whatsApp/Whatsapp.svg";
import ChatbotWhatsAppIntegrationSetup from '../chatbotWhatsAppIntegrationSetup';
import GlobalButton from '../../../utility/globalButton/button';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import integrationStyles from '../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import ShowAvailablePhoneNumbers from './showAvailablePhoneNumbers';
import globalStyles from "../../../../assets/styles/global.module.scss";
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotIntegrationsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { useIntegrationStore } from '../../../../store/integrationStore';

declare global {
    interface Window {
        fbAsyncInit: () => void;
        FB: any;
    }
}


interface addChatbotIntegrationDetailsInterface {
    chatbot_id: string,
    integrated_channel_id: string
}

interface TypeOfTemp extends metaIntegrationPhoneNumberDataNew {
    meta_integration_whatsapp_id: number | string;
    waba_id: string;
    waba_name: string;
}


const ChatbotWhatsAppIntegration = () => {
    const smallScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)')
    const [flagWhatsappIntegrationExist, setflagWhatsappIntegrationExist] = useState<boolean | null>(null)
    const [searchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');
    let pathname = window.location.pathname.toLowerCase();

    const { setFlagLoading, flagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotIntegrationData, getChatbotIntegrationData, metaCredentials, GetMetaCredentials } = useContext(MetaContext) as MetaContextPayload;
    const { setShowIntegrationDetails } = useContext(MetaContext) as MetaContextPayload;
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { getMetaIntegrationList, globalIntegrationTypeList, integrationListNewStructure, setIntegrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { setFlagOpenWabaVerificationForm, getWabaApprovalStatus, setFlagIntegrationNotAvailablePopup } = useIntegrationStore((useShallow((state) => ({
        setFlagOpenWabaVerificationForm: state.setFlagOpenWabaVerificationForm,
        getWabaApprovalStatus: state.getWabaApprovalStatus,
        setFlagIntegrationNotAvailablePopup: state.setFlagIntegrationNotAvailablePopup
    }))))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [phoneNumberIntegrate, setPhoneNumberIntegrate] = useState<string>("")
    const [linkedPhoneNumberData, setLinkedPhoneNumberData] = useState<TypeOfTemp[]>([])
    const [flagShowAvailableNumbers, setFlagShowAvailableNumbers] = useState<boolean>(false)
    const [availablePhoneNumberData, setAvailablePhoneNumberData] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[]>([])
    const [addChatbotIntegrationDetails, setAddChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [removeChatbotIntegrationDetails, setRemoveChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [responsePayload, setResponsePayload] = useState({
        response1: "",
        response2: ""
    })

    useEffect(() => {
        getmetaIntegrations()
    }, [])

    useEffect(() => {
        const updatedBreadcrumbs = [
            { ...homeBreadcrumb},
            AIChatbotBreadcrumb,
            { ...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}` },
            ...((pathname === "/chatbot/viewchatbot/channels/whatsapp") ? [{ name: "WhatsApp Integration", path: `${pathname}?chatbot_id=${chatbot_id}`, isActive: true }] : []),
            ...((pathname === "/chatbot/viewchatbot/integration/whatsapp") ? [{ ...chatbotIntegrationsBreadcrumb, path: `/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}` }, { name: "WhatsApp", path: `${pathname}?chatbot_id=${chatbot_id}`, isActive: true }] : []),
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    async function getmetaIntegrations() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await getMetaIntegrationList(true)
        if (!(response.status)) {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    useEffect(() => {
        let ids: any = []
        if (integrationListNewStructure !== null) {
            if (integrationListNewStructure.length > 0) {
                let whatsappFilter = integrationListNewStructure?.filter((integration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => integration?.channel_name.toLowerCase() == "whatsapp");
                whatsappFilter?.map((data: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => {
                    if ("meta_integration_phone_number_data" in data) {
                        data?.meta_integration_phone_number_data.map((phoneData: metaIntegrationPhoneNumberDataNew) => {
                            phoneData.chatbot_integration_assignment_data.map((assignmentData: chatbotIntegrationAssignmentDataNew) => {
                                ids.push(String(assignmentData.chatbot_id ?? assignmentData.ai_chatbot_id))
                            })
                        })
                    }
                });
                setAvailablePhoneNumberData(whatsappFilter)
                let validID = ids.includes(chatBotDetails?.chatbot_id);

                if (validID &&
                    integrationListNewStructure.length > 0 &&
                    whatsappFilter.length > 0
                ) {
                    let temp: TypeOfTemp[] = whatsappFilter.flatMap((whatsAppData: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => {
                        if ("meta_integration_phone_number_data" in whatsAppData) {
                            return (whatsAppData.meta_integration_phone_number_data?.map((phone: metaIntegrationPhoneNumberDataNew) => ({
                                ...phone,
                                meta_integration_whatsapp_id: whatsAppData.meta_integration_whatsapp_id,
                                waba_id: whatsAppData.waba_id,
                                waba_name: whatsAppData.waba_name
                            })))
                        }
                        return [];
                    })

                    if (temp) {
                        let linkedPhoneNumber: TypeOfTemp[] = temp.filter((phoneNumber: TypeOfTemp) => phoneNumber?.chatbot_integration_assignment_data.some((chatbot) => (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id).toString() == searchParams.get('chatbot_id')))
                        if (temp) {
                            if (linkedPhoneNumber) {
                                setLinkedPhoneNumberData(linkedPhoneNumber)
                            }
                        }
                    }
                    setflagWhatsappIntegrationExist(true)
                    setShowIntegrationDetails(true)
                } else {
                    setflagWhatsappIntegrationExist(false)
                    setShowIntegrationDetails(false)
                }
            } else {
                setflagWhatsappIntegrationExist(false)
                setShowIntegrationDetails(false)
            }

        }

    }, [getChatbotIntegrationData, chatBotDetails, integrationListNewStructure])

    const [codeValue, setCodeValue] = useState({
        code: ""
    })
    const [whatsappData, setWhatsappData] = useState({
        waba_id: "",
        phone_number_id: "",
        integrated_channel_id: ""
    })

    const injectFacebookSdkScript = () => {
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s) as HTMLScriptElement;
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode!.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    // FB SDK is loaded async via script tag; when credentials arrive only after WABA approval,
    // launchWhatsAppSignup must wait for init instead of relying on the useEffect alone.
    const ensureFacebookSdkReady = (fbInit: any): Promise<void> => {
        return new Promise((resolve, reject) => {
            let settled = false;
            const finish = (error?: unknown) => {
                if (settled) return;
                settled = true;
                if (error) reject(error);
                else resolve();
            };

            const initSdk = () => {
                try {
                    // @ts-ignore
                    FB.init(fbInit);
                    finish();
                } catch (error) {
                    finish(error);
                }
            };

            if (window.FB) {
                initSdk();
                return;
            }

            window.fbAsyncInit = function () {
                initSdk();
            };

            injectFacebookSdkScript();

            const start = Date.now();
            const poll = window.setInterval(() => {
                if (settled) {
                    window.clearInterval(poll);
                    return;
                }
                if (window.FB) {
                    window.clearInterval(poll);
                    initSdk();
                } else if (Date.now() - start > 10000) {
                    window.clearInterval(poll);
                    finish(new Error("Facebook SDK not loaded"));
                }
            }, 100);
        });
    };

    useEffect(() => {
        if (userDetail.flagUser && !isOrganizationRoleAgent(userDetail) && !isAgentOrAdmin(userDetail) && userDetail?.user_organization_data?.organization_waba_approved) {
            if (!metaCredentials) {
                GetMetaCredentials();
            }
        }
    }, [metaCredentials, userDetail])

    useEffect(() => {
        if (metaCredentials) {
            let whatsappConfig = metaCredentials.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")
            window.fbAsyncInit = function () {
                // @ts-ignore
                FB.init(whatsappConfig.fb_init);
            };
            injectFacebookSdkScript();
        }
    }, [metaCredentials]);
    useEffect(() => {
        const sessionInfoListener = (event: MessageEvent) => {
            if (event.origin !== "https://www.facebook.com") return;
            try {
                const data = JSON.parse(event.data);
                // Handle the data from the event
                // console.log("session info data", data);


                if (data.type === 'WA_EMBEDDED_SIGNUP') {
                    // if user finishes the Embedded Signup flow
                    if (data.event === 'FINISH') {
                        const { phone_number_id, waba_id, integrated_channel_id } = data.data;
                        setWhatsappData({ ...whatsappData, phone_number_id: phone_number_id, waba_id: waba_id, integrated_channel_id: integrated_channel_id })
                    }
                    // if user cancels the Embedded Signup flow
                    else {
                        const { current_step } = data.data;
                    }
                }
            } catch (error) {
                // Handle errors or non-JSON messages
            }
        };
        window.addEventListener('message', sessionInfoListener);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('message', sessionInfoListener);
        };
    }, [metaCredentials]);

    useEffect(() => {
        (async () => {
            let chatbot_id = searchParams.get('chatbot_id') ?? ""
            if (codeValue.code !== "" && whatsappData.waba_id !== "" && whatsappData.phone_number_id !== "" && whatsappData.integrated_channel_id !== "" && Number(chatbot_id) !== -1) {
                setFlagLoading({ ...flagLoading, flagRoundLoader: true, flagContentGenerating: false });
                let whatsappObj = {
                    waba_id: whatsappData.waba_id,
                    phone_number_id: whatsappData.phone_number_id,
                    integrated_channel_id: whatsappData.integrated_channel_id,
                    code: codeValue.code
                }
                let payload: createMetaIntegrationPayloadNew = {
                    channel_id: globalIntegrationTypeList.find((integrationType) => integrationType.channel_name.toLowerCase() == "whatsapp")?.channel_id ?? Number(process.env.REACT_APP_WHATSAPP_META_INTEGRATION_TYPE_ID),
                    meta_integration_whatsapp_data: whatsappObj,
                    channel_authoriser_user_data: {
                        authoriser_unique_id: 0,
                        authoriser_unique_name: "",
                        authoriser_unique_email: "",
                    },
                    meta_data: JSON.stringify(responsePayload)
                }
                // CommonResponseModel<integrationData>
                const response: any = await agent.createMetaIntegration.post(payload);
                if (response.status && response.data) {

                    let responseNewStructure = response.data[0]
                    let whatsappIntegrations = responseNewStructure.meta_integration_whatsapp_data.map((integration: any) => {
                        return {
                            ...integration,
                            integrated_channel_id: integration.meta_integration_whatsapp_id,
                            channel_name: 'Whatsapp'
                        }
                    })
                    setIntegrationListNewStructure([...whatsappIntegrations, ...responseNewStructure.meta_integration_facebook_data, ...responseNewStructure.meta_integration_instagram_data
                    ])
                    let sortedData = responseNewStructure.meta_integration_whatsapp_data.sort((a: globalIntegration, b: globalIntegration) => new Date(b.created_at_timestamp).getTime() - new Date(a.created_at_timestamp).getTime())
                    let data = sortedData[0]
                    let integrated_channel_id = data.meta_integration_phone_number_data.find((phoneNumber: metaIntegrationPhoneNumberData) => phoneNumber.phone_number_id == whatsappObj.phone_number_id).integrated_channel_id
                    let chatbot_id = searchParams.get('chatbot_id') || ""
                    let payload = {
                        chatbot_id: chatbot_id,
                        integrated_channel_id: integrated_channel_id
                    }
                    AddChatbotIntegration(payload)
                    let chatbotId = searchParams.get('chatbot_id') ?? chatBotDetails?.chatbot_id.toString()
                    if (chatbotId) {
                        const response = await GetChatbotIntegrationData(chatbotId, "")
                        if (response.status) {
                            if (response.data && response.data.length > 0) {
                                setShowIntegrationDetails(true)
                            }
                        } else {
                            handleError(response);
                        }
                    }
                } else {

                    handleError(response);
                    setCodeValue({ code: "" });
                    setWhatsappData({ waba_id: "", phone_number_id: "", integrated_channel_id: "" });
                    safeLogout();
                    setFlagLoading({ ...flagLoading, flagRoundLoader: false, flagContentGenerating: false });
                }
                setCodeValue((prevState) => ({ ...prevState, code: "" }))
                setWhatsappData((prevState) => ({
                    ...prevState, waba_id: "",
                    phone_number_id: "",
                    integrated_channel_id: ""
                }))
                setResponsePayload({
                    response1: "",
                    response2: ""
                })


            }
        })()
    }, [codeValue, whatsappData])

    const safeLogout = (): void => {
        // Check the user's current login status
        window.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
                // User is logged in to your app and Facebook.
                // It's safe to call logout
                window.FB.logout((logoutResponse: any) => {
                    // Handle post-logout logic here
                });
            } else {
                console.log('User was not logged in via Facebook SDK. No need to log out.');
                // Handle scenarios where the user was not logged in
            }
        });
    };

    const getWabaApprovalStatusApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getWabaApprovalStatus(String(userDetail?.user_organization_data?.organization_id ?? ''));
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        return res;
    }

    // Ensure FB is initialized before calling this function
    const launchWhatsAppSignup = async () => {
        let metaCredentialsData = metaCredentials;
        if(!userDetail?.user_organization_data?.organization_waba_approved){
            const wabaApprovalStatus = await getWabaApprovalStatusApi();
            const status = wabaApprovalStatus?.data?.organization_waba_integration_status?.toLowerCase();
            if(status !== 'approved'){
                setFlagOpenWabaVerificationForm(true);
                return;
            } else {
                let whatsappConfig = metaCredentialsData?.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")
                if(!whatsappConfig){
                    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
                    metaCredentialsData = (await GetMetaCredentials())?.data ?? null;
                    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
                }
            }
        }
        if (metaCredentialsData) {
            let whatsappConfig = metaCredentialsData?.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")
            if (!whatsappConfig?.fb_init) {
                showError("WhatsApp configuration not available. Please try again.");
                return;
            }

            if(!whatsappConfig?.flag_can_integrate){
                setFlagIntegrationNotAvailablePopup(true);
                return;
            }

            try {
                setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
                await ensureFacebookSdkReady(whatsappConfig.fb_init);
            } catch (error) {
                console.error("Facebook SDK not loaded", error);
                showError("Facebook SDK failed to load. Please refresh and try again.");
                return;
            } finally {
                setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
            }

            // @ts-ignore
            window.FB.login(function (response: any) {
                if (response.authResponse) {
                    const accessToken = response.authResponse.accessToken;
                    if (response.authResponse.code) {
                        setCodeValue({ ...codeValue, code: response.authResponse.code })
                    }
                } else {
                    showError("User cancelled login or did not fully authorize.")
                }
            },

                whatsappConfig?.signup_config
            );
        }
    };
    const deleteChatbotIntegration = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'whatsapp')?.channel_id.toString() || ''
        const response = await agent.removeChatbotIntegration.delete(channel_id, removeChatbotIntegrationDetails.chatbot_id,
            removeChatbotIntegrationDetails.integrated_channel_id
        );
        if (response.status) {
            await getmetaIntegrations()
            showSuccess("Integration Removed Successfully")
        } else {
            handleError(response);
        }
        setShowDeleteConfirmation(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }


    const handleRemoveChatbotIntegration = (phone_number_id: string, display_phone_number: string, integrated_channel_id: string) => {
        if (integrationListNewStructure) {
            let chatbot_id = searchParams.get('chatbot_id')
            if (chatbot_id) {
                setRemoveChatbotIntegrationDetails(
                    {
                        chatbot_id: chatbot_id,
                        integrated_channel_id: integrated_channel_id
                    }
                )
            }
            setShowDeleteConfirmation(true)
            setPhoneNumberIntegrate(display_phone_number)
        }
    }
    function addChatbotIntegration(phone_number_id: string, display_phone_number: string, integrated_channel_id: string, event?: React.MouseEvent<HTMLButtonElement>) {
        if (event) {
            handleClick(event)
        }
        let chatbot_id = searchParams.get('chatbot_id')
        if (chatbot_id) {
            setAddChatbotIntegrationDetails((prevState) => ({
                ...prevState,
                chatbot_id: chatbot_id,
                integrated_channel_id: integrated_channel_id
            }))
        }
        setPhoneNumberIntegrate(display_phone_number)
    }
    async function AddChatbotIntegration(addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface) {
        handleCloseConfirmationPopover()
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await agent.addChatbotIntegration.post(addChatbotIntegrationDetails)
        if (response.status) {
            await getmetaIntegrations()
            showSuccess("Integration Successfull!")
        } else {
            handleError(response);
        }
        setFlagShowAvailableNumbers(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    const [showConfirmationPopover, setShowConfirmationPopover] = React.useState(false);

    const [confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setConfirmationPopoverAnchorEl(event.currentTarget);
        setShowConfirmationPopover(true)
    };

    const handleCloseConfirmationPopover = () => {
        setConfirmationPopoverAnchorEl(null);
        setShowConfirmationPopover(false)
    };

    return (
        <>
            {flagShowAvailableNumbers &&
                <ShowAvailablePhoneNumbers
                    flagShowAvailableNumbers={flagShowAvailableNumbers}
                    setFlagShowAvailableNumbers={setFlagShowAvailableNumbers}
                    smallScreen={smallScreen}
                    showConfirmationPopover={showConfirmationPopover}
                    confirmationPopoverAnchorEl={confirmationPopoverAnchorEl}
                    handleCloseConfirmationPopover={handleCloseConfirmationPopover}
                    addChatbotIntegrationDetails={addChatbotIntegrationDetails}
                    AddChatbotIntegration={AddChatbotIntegration}
                    availablePhoneNumberData={availablePhoneNumberData}
                    handleRemoveChatbotIntegration={handleRemoveChatbotIntegration}
                    displayPhoneNumber={phoneNumberIntegrate}
                    launchWhatsAppSignup={launchWhatsAppSignup}
                    saveChatbotIntegrationData={addChatbotIntegration}
                />

            }
            {(flagWhatsappIntegrationExist == false) ?
                <>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.startAlignmentStyle} ${globalStyles.containerFlexWrap} ${globalStyles.fullwidth} `} gap={2} pt={1}>
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={`${globalStyles.createChatbotContainer} ${globalStyles.containerFlexWrap}`} gap={"13px"} mt={1}>
                                <Grid item className={globalStyles.displayFlexStyle}>
                                    <img alt="" src={whatsAppIcon} className={integrationStyles.whatsappIntegrationIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography className={integrationStyles.whatsappIntegrationFontStyle}>Integrate with your WhatsApp Business Account</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={globalStyles.wpIntegrationWrapper}>
                            {
                                (!getChatbotIntegrationData && (integrationListNewStructure && integrationListNewStructure?.filter((integration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => integration.channel_name.toLowerCase() === "whatsapp").length > 0)) ?
                                    <>
                                        <Grid container className={globalStyles.flexColumn}>
                                            <Grid item>
                                                {/* <ChatbotWhatsAppIntegrationSetup launch={launchWhatsAppSignup} /> */}
                                                <span className={globalStyles.textWpInt} >This Chatbot is not linked with any WhatsApp Business Number yet. </span>
                                            </Grid>
                                            <Grid item className={globalStyles.padTop}>
                                                <GlobalButton buttonText={"Add WhatsApp Number"} className='primaryButtonStyle' onClick={() => { setFlagShowAvailableNumbers(true) }} sx={{ padding: "6px 20px !important" }} startIcon={<IconsColor fillColor="#FFFFFF" iconName="plus" width="15px" height="15px" />} />
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <Grid container className={globalStyles.flexColumn}>
                                        <Grid item>
                                            <ChatbotWhatsAppIntegrationSetup launch={launchWhatsAppSignup} />
                                        </Grid>
                                        <Grid item sx={{ borderTop: "1px solid #E1DCDC", paddingTop: "20px" }}>
                                            <GlobalButton buttonText={"Integrate WhatsApp Business Account"} className='primaryButtonStyle' onClick={launchWhatsAppSignup} />
                                        </Grid>
                                    </Grid>
                            }

                        </Grid>
                    </Grid>
                </>
                :
                <>
                    {linkedPhoneNumberData.length > 0 &&
                        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapLength} `} sx={{ padding: { xs: "15px 7px", lg: "15px 15px 15px 5px" } }} mt={{ xs: 1, lg: 0 }}>
                            <Grid item>
                                <Grid container className={globalStyles.gapLess}>
                                    {linkedPhoneNumberData.map((phoneNumberData: TypeOfTemp, index) => (
                                        <AccountInformationCard
                                            key={index}
                                            flagDelete={false}
                                            title={`WhatsApp Account ${index + 1}`}
                                            currentlySelected={true}
                                            showRemoveChatbotIntegration={true}
                                            removeChatbotIntegration={(phone_number_id: string, integrated_channel_id?: string) => { handleRemoveChatbotIntegration(phone_number_id, phoneNumberData.display_phone_number, integrated_channel_id || "") }}
                                            details={{
                                                display_phone_number: phoneNumberData.display_phone_number,
                                                quality_rating: phoneNumberData.quality_rating,
                                                phone_number_id: phoneNumberData.phone_number_id,
                                                linked_chatbots: phoneNumberData.chatbot_integration_assignment_data?.filter((chatbot) => !(chatbot.is_workflow_chatbot)), 
                                                linked_workflows: phoneNumberData.chatbot_integration_assignment_data?.filter((chatbot) => chatbot.is_workflow_chatbot),
                                                business_name: phoneNumberData.verified_name,
                                                integrated_channel_id: String(phoneNumberData.integrated_channel_id)
                                            }}
                                            flagIntegration={true}
                                        />
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item>

                                <GlobalButton onClick={() => { setFlagShowAvailableNumbers(true) }} buttonText={"Add WhatsApp Number"} className={'blackShadowedButton'}
                                    startIcon={<IconsColor fillColor="#A5A5A5" iconName="plus" width="19px" height="19px" />}
                                />
                            </Grid>

                        </Grid>}
                    {
                        showDeleteConfirmation &&
                            <GlobalDeletePopup
                                open={showDeleteConfirmation}
                                title="Undeploy Chatbot Confirmation"
                                deleteDescription={`Are you sure you want to undeploy ${chatBotDetails?.chatbot_name} from ${phoneNumberIntegrate}`}
                                onClose={() => { setShowDeleteConfirmation(false) }}
                                onDelete={deleteChatbotIntegration}
                                primaryButtonText="Undeploy"
                            />
                    }
                </>
            }

        </>
    )
}

export default ChatbotWhatsAppIntegration;